import { translateAsync } from '.';
import useI18n from '@/js/utils/I18n';

const i18n = useI18n();
export const getTranslations = async (translations): Promise<{ [key: string]: string }> => {
    await i18n;
    const promises = [];
    for (const key of Object.keys(translations)) {
        if (typeof translations[key] === 'string') {
            promises.push((async () => (translations[key] = await translateAsync(translations[key])))());
        } else if (Array.isArray(translations[key])) {
            for (const [i, value] of translations[key].entries()) {
                promises.push((async () => (translations[key][i] = await translateAsync(value)))());
            }
        } else {
            promises.push((async () => (translations[key] = await getTranslations(translations[key])))());
        }
    }
    await Promise.all(promises);
    return translations;
};
